module.exports = __webpack_public_path__ + "img/unl_identidad.57fab954.svg";